// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components'

import SubtitleIcon from '../../../../assets/images/subtitle-icon.svg';
import Tooltips from '../../../Tooltips';

const otherS = {
  SubtitlesIcon: styled.img.attrs({ src: SubtitleIcon, alt: 'subtitle-icon'})<{ disable: boolean }>`
    cursor: pointer;
    opacity: ${props => props.disable ? '0.3' : '1'};
  `,
  TooltipsContainer: styled.div`
    position: absolute;
    bottom: 36px;
    right: 102px;
    display: none;
  `,
  Tooltips: styled(Tooltips).attrs({ direction: 'bottomRight' })``,
}

const S = {
  ...otherS,
  SubtitlesContainer: styled.div`
    &:hover ${otherS.TooltipsContainer}{
      display: flex;
    }
  `,
}

export { S as default }
